import type StudentSearchCriteria from '@/types/StudentSearchCriteria';
import { fsumClient } from '@/services/FsumHttpClient';
import type { FlightSchoolCourseStudent } from '@/types/FlightSchoolStudent';
import type { UserFaaExamScheduleRequest } from '@/types/Request/UserFaaExamScheduleRequest';
import type FlightSchoolCourse from '@/types/FlightSchoolCourse';
import type FlightSchool from '@/types/FlightSchool';

async function studentSearch(
    criteria: StudentSearchCriteria,
): Promise<FlightSchoolCourseStudent[]> {
    return fsumClient.post('/v1/students', criteria);
}

async function saveExamSchedule(request: UserFaaExamScheduleRequest): Promise<void> {
    return fsumClient.patch(`/v1/students/${request.studentId}/ratings/${request.ratingUuid}/exam-date`, { examDate: request.examDate });
}

async function getAllLockedOutStudents(): Promise<FlightSchoolCourseStudent[]> {
    return fsumClient.get('/v1/students/locked-out');
}

async function getCourseStudentsByRatingUuid(
    school: FlightSchool,
    course: FlightSchoolCourse,
    ratingUuid: string,
): Promise<FlightSchoolCourseStudent[]> {
    return fsumClient.get(`/v1/flight-schools/${school.id}/courses/${course.certificate.uuid}/ratings/${ratingUuid}/students`);
}

export default {
    studentSearch,
    saveExamSchedule,
    getAllLockedOutStudents,
    getCourseStudentsByRatingUuid,
};
